import moment from 'moment';
import angular from 'angular';

import gridHeight from '../core/shared-service/grid-utils';
import templateUrl from './sub-entity.html';

export const subEntities = {
  templateUrl,
  bindings: {
    invitedEntity : '<', // Les données d'une entité.,
    addNewButton:'<',
    opened:'<', // indique si le panel est ouvert ou fermer pas defaut
    principal: '<', //le donneur d'ordre
    navigationContext: '@'
  },
  controllerAs: 'ctrl',
  controller: class SubEntities {
    /*@ngInject*/
    constructor($scope, $state, $translate, AuthSvc,KissSellerSvc, $location, invitedEntitySvc, logger, $uibModal, SessionSvc, PrincipalSvc) {
      this.$scope = $scope;
      this.$state = $state;
      this.AuthSvc = AuthSvc;
      this.$translate = $translate;
      this.KissSellerSvc = KissSellerSvc;
      this.gridApi = null;
      this.$location = $location;
      this.invitedEntitySvc = invitedEntitySvc;
      this.logger = logger;
      this.$uibModal = $uibModal;
      this.SessionSvc = SessionSvc;
      this.PrincipalSvc = PrincipalSvc;
    }

    $onInit() {
        this.legalEntity = this.invitedEntity.legalEntity;
        this.showCreationSub = this.addNewButton && this.AuthSvc.isAuthorized('CONFIGURATOR') && (this.legalEntity.countryCode !== 'FR' || this.legalEntity.idNational != null);
        this.isDisabled = true;
        this.isBuyer = true;
        //variable permettant de voir si on doit afficher le bouton d'activation du bouton pdp réception
        this.disableBtnPdpRe = true;
        this.isAuthorized = this.SessionSvc.getCurrentUser().roles.includes("SUPPORT");
        var relationsTemplate =
            '<div ng-show="row.entity.relations > 0" class="ui-grid-cursor-pointer text-center" ' +
            'ui-sref="app.principal.invbuy-subentity-relations({subEntityId : row.entity.id})"><i class="fa fa-search"></i></div>';
         var erreurTemplate ='<div  class="ui-grid-cell-contents" > {{row.entity.getStatusLabel()}}  '+
         '<i ng-show="grid.appScope.ctrl.rejectedsubentity({status: row.entity.status})" " class="fa fa-info-circle ui-grid-cursor-pointer text-center" aria-hidden="true" ng-click="grid.appScope.ctrl.errorForm({subEntityCode : row.entity.code},{subEntityId : row.entity.id})" ></i></div>'

      this.subEntitiesGridOptions = {
        columnDefs: [
          {
            name: 'name',
            displayName: 'kiss_seller.edit.sub_entity.name',
            headerCellFilter: 'translate',
            minWidth: '180',
            cellFilter: 'translate',
            cellTemplate: this.getCellTemplate(),
            cellClass: 'cursor-default',
            sort: { direction: 'asc', priority: 0 }
          },
          {
            name: 'code',
            displayName: 'kiss_seller.edit.sub_entity.code',
            headerCellFilter: 'translate',
            width: '120',
            cellTemplate: this.getCellTemplate(),
            cellClass: 'cursor-default'
          },
          {
            name: 'getTypeLabel()',
            displayName: 'kiss_seller.edit.sub_entity.type',
            headerCellFilter: 'translate',
            width: '100',
            cellTemplate: this.getCellTemplate(),
            cellClass: 'cursor-default text-center'
          },
          {
            name: 'getAddress()',
            displayName: 'kiss_seller.edit.sub_entity.address',
            headerCellFilter: 'translate',
            minWidth: '180',
            cellTemplate: this.getCellTemplate(),
            cellClass: 'cursor-default'
          },
          {
            name: 'getCountryLabel()',
            displayName: 'kiss_seller.edit.sub_entity.country',
            headerCellFilter: 'translate',
            width: '100',
            cellTemplate: this.getCellTemplate(),
            cellClass: 'cursor-default text-center'
          },
          {
            name: 'getStatusLabel()',
            displayName: 'kiss_seller.edit.sub_entity.status',
            headerCellFilter: 'translate',
            width: '80',
            cellTemplate: erreurTemplate ,
            cellClass: 'defaultcursor',
          },
          {
            name: 'relations',
            displayName: 'kiss_seller.edit.sub_entity.relations',
            headerCellFilter: 'translate',
            cellTemplate: relationsTemplate,
            cellClass: 'pointer',
            width: '80',
          },
        ],
        exporterOlderExcelCompatibility: false,
        enableRowSelection: true,
        enableSelectAll: true,
        selectionRowHeaderWidth: 30,
        useExternalPagination: false,
        useExternalSorting: false,
        onRegisterApi: gridApi => {
           let vm = this;
           this.gridApi = gridApi;
           gridApi.selection.on.rowSelectionChanged(this.$scope, () => {
               this.enableIfRejectedSubentity(vm);
           });
           gridApi.selection.on.rowSelectionChangedBatch(this.$scope, () => {
               this.enableIfRejectedSubentity(vm);
           });
        },
        enableSorting: true,
        enableGridMenu: false,
        enableColumnMenus: false,
        paginationPageSizes: [5, 10, 20],
        paginationPageSize: 5,
        data: {}
      };

        if (!this.$location.url().toString().includes('details-companies')) {
            this.subEntitiesGridOptions.columnDefs[6].visible = false;
        }

        if (this.invitedEntity.entityType === "SELLER" || !(this.invitedEntity.status === "ACTIVE")) {
            this.subEntitiesGridOptions.selectionRowHeaderWidth = 0;
            this.isBuyer = false;
        }

        if(this.isDoBuyer()){
            this.subEntitiesGridOptions.selectionRowHeaderWidth = 30;
        }
        this.search();
    }
    getCellTemplate () {
        if(this.navigationContext === 'consultForDo'){
            return `<a class="grid-cell-link" ui-sref="app.principal.consult.details_subentities({subEntityId : row.entity.id})">
                  <div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div>
                </a>`;
        }
        return `<a class="grid-cell-link" ui-sref="app.invitedentity.details_subentities({subEntityId : row.entity.id ,invitedEntityId:${this.invitedEntity.id}})">
                  <div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div>
                </a>`;

      }

      openCreateNewSubentity(){
        this.$state.go('app.principal.consult.details_subentity',{ legalEntityId: this.invitedEntity.legalEntity.id });
      }
    enableIfRejectedSubentity(vm) {
        const selectedRows = this.gridApi.selection.getSelectedRows();
        if (selectedRows.length > 0) {
            angular.forEach(selectedRows, function (row) {
                vm.isDisabled = row.status !== "DISCARDED";
            })
            this.disableBtnPdpRe = false;

        } else {
            vm.isDisabled = true;
            this.disableBtnPdpRe = true;
        }
    }

      onRegisterApi(gridApi) {
      this.gridApi = gridApi;
    }

    getGridHeight() {
      return gridHeight(this.gridApi, this.subEntitiesGridOptions.rowHeight);
    }

    reInviteRejectedSubEntities() {

        var rejectedSubEntitiesIds = [];

        var selectedRows = this.gridApi.selection.getSelectedRows();
        angular.forEach(selectedRows, function (row) {
            if (row.status === "DISCARDED") {
                rejectedSubEntitiesIds.push(row.code);
            }
        });

        this.$uibModal
            .open({
                component: 'modalReInviteRejectedSubEntityCtrl',
                size: 'lg',
                resolve: {
                    rejectedCodes: () => {
                        return rejectedSubEntitiesIds;
                    },
                    invitedEntityId: ()=> {
                        return this.invitedEntity.id;
                    }
                },
            })
            .result.then({}, {});

    }

    /**
     * Export csv
     */
    exportCsv() {
      this.subEntitiesGridOptions.exporterCsvFilename = `etablissements-entite-legale_${
        this.invitedEntity.legalEntity.id
      }_${moment().format('DDMMYYYY')}.csv`;
      this.subEntitiesGridOptions.exporterHeaderFilter = this.$translate.instant;
      this.gridApi.exporter.csvExport('all', 'all');
    }

    /**
     * Recherche des établissements
     */
    search() {
        this.subEntitiesGridOptions.data = this.KissSellerSvc.getSubEntities(this.invitedEntity.legalEntity.id).then(
            entities => {
                this.subEntitiesGridOptions.data = entities;
                this.shwoPdpRe = this.canEditPdpRe(entities) && this.isDoBuyer() && this.isAuthorized;
                if(this.shwoPdpRe) this.insertPdpColumns();
            }
        )
    }

    insertPdpColumns(){
        let lastColumns = [
            this.subEntitiesGridOptions.columnDefs.pop(),
        ]
        const pdpColumns = [
            {
                name: 'getPdpReDate("startDate")',
                displayName: 'kiss_seller.edit.pdp_re.start_date',
                headerCellFilter: 'translate',
                cellTemplate: this.getCellTemplate(),
                cellClass: 'cursor-default text-center',
            },
            {
                name: 'getPdpReDate("endDate")',
                displayName: 'kiss_seller.edit.pdp_re.end_date',
                headerCellFilter: 'translate',
                cellTemplate: this.getCellTemplate(),
                cellClass: 'cursor-default text-center',
            },
        ]
        this.subEntitiesGridOptions.columnDefs.push(...pdpColumns, ...lastColumns.reverse());
    }

    errorForm(subEntityCode,subEntityId) {
      this.PrincipalSvc.getSubEntityRejectionInfo(subEntityId.subEntityId).then(
        data => {
        this.$uibModal.open({
            component: 'errorModal',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            resolve: {
            modalMessage: () => {
                return {
                    data: data,
                    subEntityCode:subEntityCode.subEntityCode,
                };
            }
        }
        }).result.then(
            () =>{} ,
            () => {}
        )},
        () => {});

    }
    rejectedsubentity(status){
      return status.status==='DISCARDED' ;
    }

    activatePdpReForSubEntities() {
      this.updatePdpForSubEntities();
    }

      isDoBuyer(){
        return this.principal && this.principal.principal.detail.profilBuyer
      }

      /**
       * Récupération des ids sélectionnés
       */
      getSubEntitiesIdsSelected() {
          let ids = [];
          if  (!(this.gridApi === undefined || this.gridApi.selection === undefined)){
              let selectedRows = this.gridApi.selection.getSelectedRows();
              for (const element of selectedRows) {
                  ids.push(element.id);
              }
          }
          return ids;
      }

      /**
       * Mise à jour des pdp réception établissements
       */
      updatePdpForSubEntities() {
          this.$uibModal
              .open({
                  component: 'modalPdpReSubEntity',
                  size: 'md',
                  resolve: {
                      nbEtab: () => {
                          return this.getSubEntitiesIdsSelected().length;
                      }
                  },
              }).result.then(
              (dates) => {
                  let LegalEntitiesPlatformPartnerHistoryDto ={
                      entitiesIds:this.getSubEntitiesIdsSelected(),
                      pdp:{
                          startDate:dates.pdpStartDate,
                          endDate:dates.pdpEndDate
                      }
                  }
                  this.PrincipalSvc.createOrUpdateSubEntPdp(LegalEntitiesPlatformPartnerHistoryDto).then(
                      (data)=>{
                          if(data.length != this.getSubEntitiesIdsSelected().length)
                              this.logger.success('Les établissements ont été mises à jour');
                          if(data.length !=0 )
                          {
                              this.$uibModal
                                  .open({
                                      component: 'modalUnUpdatePdpSubEntity',
                                      size: 'md',
                                      resolve: {
                                          etab: () => {
                                              return data;
                                          }
                                      },
                                  })
                          }

                      }
                  )

              }
          );
      }

      // afficher le bloc Pdp réception si au moins l'un des pays des sous entités fait partie de la France métropolitaine et outre-mer
      canEditPdpRe(entities) {
          if (!Array.isArray(entities)) {
              return false;
          }

          return entities.some(
              (subEntity) => this.PrincipalSvc.getSocFr().includes(subEntity.countryCode)
          );
      }

  }
};
